import socket from './socket';

const getContentCardDefaults = (pointSystemId, headers) =>
  socket.get(`/point-systems/${pointSystemId}/content-card-defaults`, undefined, headers);

const createContentCardDefault = (pointSystemId, data, headers) =>
  socket.post(`/point-systems/${pointSystemId}/content-card-defaults`, data, headers);

const updateContentCardDefault = (id, data, headers) =>
  socket.patch(`/content-card-defaults/${id}`, data, headers);

const deleteContentCardDefault = (id, headers) =>
  socket.delete(`/content-card-defaults/${id}`, undefined, headers);

export default {
  getContentCardDefaults,
  createContentCardDefault,
  updateContentCardDefault,
  deleteContentCardDefault,
};

